import { LogLevel } from './lib/logger';
import type { ColorScheme, PrimaryColor } from './styles/theme/types';

export interface Config {
  site: {
    name: string;
    description: string;
    colorScheme: ColorScheme;
    primaryColor: PrimaryColor;
    themeColor: string;
    version: string;
  };
  logLevel: keyof typeof LogLevel;
}

export const config = {
  site: {
    name: 'Optima Tax - Client Portal and Optima Tax Shield',
    description: '',
    colorScheme: 'light',
    themeColor: '#090a0b',
    primaryColor: 'neonBlue',
    version: '0.0.0',
  },
  logLevel: LogLevel.ALL,
} satisfies Config;


export interface AppConfig {
	name: string;
	description: string;
	direction: "ltr" | "rtl";
	language: string;
	theme: "light" | "dark" | "system";
	themeColor: string;
	primaryColor: PrimaryColor;
	logLevel: keyof typeof LogLevel;
}

export const appConfig: AppConfig = {
  name: 'Optima Tax - Client Portal and Optima Tax Shield',
	description: "",
	direction: "ltr",
	language: "en",
	theme: "light",
	themeColor: "#090a0b",
	primaryColor: "neonBlue",
	logLevel:  LogLevel.ALL,
};
